'use client'

import ErrorPage from '@/components/pages/(main)/error';

export default function Error(props: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return <ErrorPage {...props}/>;
}